import { MapCoordinates } from '@freelancer/datastore/core';
import { generateId } from '@freelancer/datastore/testing';
import { Country, generateCountryObject } from '../countries';
import {
  FreelancerReputation,
  generateFreelancerReputationsObject,
} from '../freelancer-reputations';
import {
  generateProfileViewUserObjects,
  ProfileViewUser,
} from '../profile-view-users';
import { Skill } from '../skills';
import { User } from '../users';
import { SearchUser } from './search-users.model';

export interface GenerateSearchUsersOptions {
  readonly avatar?: string;
  readonly avatarLarge?: string;
  readonly country?: Country;
  readonly hourlyRate?: number;
  readonly isOnline?: boolean;
  readonly poolIds?: readonly number[];
  readonly profileDescription?: string;
  readonly rating?: number;
  readonly reputation?: FreelancerReputation;
  readonly reviews?: number;
  readonly searchCoordinates?: MapCoordinates;
  readonly skills?: readonly Skill[];
  readonly tagLine?: string;
  readonly users: readonly User[];
}

export function generateSearchUsersObjects({
  avatar,
  avatarLarge = avatar,
  country = generateCountryObject(),
  hourlyRate = 2, // HourlyRateFilterRange.MINIMUM
  isOnline = false,
  poolIds = [],
  profileDescription = 'This is my profile description.',
  rating = 5,
  reputation = generateFreelancerReputationsObject({
    freelancerId: generateId(),
  }),
  reviews = 0,
  searchCoordinates,
  skills = [],
  tagLine = 'This is my tagline.',
  users,
}: GenerateSearchUsersOptions): readonly SearchUser[] {
  const profileViewUser = generateProfileViewUserObjects({
    users,
  });

  return profileViewUser.map(user => ({
    ...user,
    avatar,
    avatarLarge,
    country,
    hourlyRate,
    isOnline,
    poolIds,
    profileDescription,
    rating,
    reputation,
    reviews,
    searchCoordinates,
    skills,
    tagLine,
  }));
}

export interface GenerateSearchUserOptions {
  readonly avatar?: string;
  readonly country?: Country;
  readonly isOnline?: boolean;
  readonly rating?: number;
  readonly reputation?: FreelancerReputation;
  readonly reviews?: number;
  readonly searchCoordinates?: MapCoordinates;
  readonly user: ProfileViewUser;
}

export function generateSearchUsersObject({
  avatar,
  country = generateCountryObject(),
  isOnline = false,
  rating = 5,
  reputation = generateFreelancerReputationsObject({
    freelancerId: generateId(),
  }),
  reviews = 0,
  searchCoordinates,
  user,
}: GenerateSearchUserOptions): SearchUser {
  return {
    ...user,
    avatar,
    avatarLarge: avatar,
    country,
    isOnline,
    rating,
    reputation,
    reviews,
    searchCoordinates,
  };
}
